import { isStepUpRequiredError } from '~/repositories/StepUpRepository';
import { StepUpCancelledError } from '~/stores/StepUp';

export const getErrorCode = (error: unknown): string | undefined =>
  typeof error === 'object' && error !== null && typeof (error as { code?: unknown }).code === 'string'
    ? (error as { code: string }).code
    : undefined;

export const isStepUpError = (error: unknown) => error instanceof StepUpCancelledError || isStepUpRequiredError(error);
